<div class="soft-ds-drdd-trigger">
  <soft-ds-prev-curr-next-navigation
    [bordered]="false"
    [disabled]="disabled()"
    (previous)="onTriggerPrev()"
    (today)="onTriggerToday()"
    (next)="onTriggerNext()"
    [style.--btn-size]="navBtnSize()"
  />

  <button
    cdkOverlayOrigin
    #origin="cdkOverlayOrigin"
    type="button"
    class="soft-ds-drdd-trigger-btn ds-body-2"
    [class.is-placeholder]="!triggerLabel()"
    [style.height]="triggerHeight()"
    [disabled]="disabled()"
    [attr.aria-expanded]="open()"
    aria-haspopup="dialog"
    (click)="onTriggerClick()"
  >
    {{ triggerLabel() ?? (placeholder() | translate) }}
  </button>
</div>

<soft-ds-overlay
  [(open)]="open"
  [originElement]="origin"
  [content]="pickerPanel"
  [width]="'fit-content'"
  [dividers]="false"
  [trapFocus]="true"
  [autoCaptureFocus]="true"
  [offset]="4"
/>

<ng-template #pickerPanel>
  <div
    class="soft-ds-drdd-root"
    role="dialog"
    [attr.aria-label]="'#UI_CORE.COMPONENTS.DATE_RANGE_DROPDOWN.DIALOG_LABEL' | translate"
  >
    <div class="soft-ds-drdd-body">
      @if (showShortcuts() && allShortcuts().length) {
        <div
          class="soft-ds-drdd-shortcuts"
          [attr.aria-label]="'#UI_CORE.COMPONENTS.DATE_RANGE_DROPDOWN.SHORTCUTS' | translate"
        >
          <span class="soft-ds-drdd-shortcuts-heading ds-caption">
            {{ '#UI_CORE.COMPONENTS.DATE_RANGE_DROPDOWN.SHORTCUTS' | translate }}
          </span>
          @for (s of allShortcuts(); track s.id) {
            <button
              class="soft-ds-drdd-shortcut"
              type="button"
              [class.is-selected]="activeShortcut() === s.id"
              (click)="onSelectShortcut(s)"
            >
              {{ shortcutLabel(s) | translate }}
            </button>
          }
        </div>
      }

      <div class="soft-ds-drdd-panel">
        <div class="soft-ds-drdd-inputs">
          <div class="soft-ds-drdd-input-group">
            <span class="soft-ds-drdd-input-label ds-caption">
              {{ '#UI_CORE.COMPONENTS.DATE_RANGE_DROPDOWN.FROM' | translate }}
            </span>
            <label class="soft-ds-drdd-input-shell">
              <soft-ds-icon
                name="fa-regular fa-calendar"
                class="soft-ds-drdd-input-icon"
                aria-hidden="true"
              />
              <input
                type="text"
                class="soft-ds-drdd-input"
                [attr.aria-label]="'#UI_CORE.COMPONENTS.DATE_RANGE_DROPDOWN.FROM' | translate"
                [ngModel]="displayFrom()"
                (ngModelChange)="displayFromInput.set($event)"
                (blur)="onDisplayFromBlur(displayFrom())"
              />
            </label>
          </div>
          <div class="soft-ds-drdd-input-group">
            <span class="soft-ds-drdd-input-label ds-caption">
              {{ '#UI_CORE.COMPONENTS.DATE_RANGE_DROPDOWN.TO' | translate }}
            </span>
            <label class="soft-ds-drdd-input-shell">
              <soft-ds-icon
                name="fa-regular fa-calendar"
                class="soft-ds-drdd-input-icon"
                aria-hidden="true"
              />
              <input
                type="text"
                class="soft-ds-drdd-input"
                [attr.aria-label]="'#UI_CORE.COMPONENTS.DATE_RANGE_DROPDOWN.TO' | translate"
                [ngModel]="displayTo()"
                (ngModelChange)="displayToInput.set($event)"
                (blur)="onDisplayToBlur(displayTo())"
              />
            </label>
          </div>
        </div>

        <div class="soft-ds-drdd-calendar-shell">
          @defer {
            <soft-date-range-dropdown-mobiscroll-host
              [value]="mbscValue()"
              [showWeekNumbers]="showWeekNumbers()"
              [dayNamesMin]="dayNamesMin()"
              [refDate]="refDate()"
              [themeVariant]="themeVariant()"
              (valueChange)="onPickerValueChange($event)"
            />
          }
        </div>
      </div>
    </div>

    <div class="soft-ds-drdd-footer">
      <button
        type="button"
        class="soft-ds-drdd-footer-total"
        [class.is-selected]="activeShortcut() === 'all'"
        (click)="onSelectTotalRange()"
      >
        <soft-ds-icon
          name="fa-regular fa-calendar"
          class="soft-ds-drdd-footer-icon"
          aria-hidden="true"
        />
        {{ '#UI_CORE.COMPONENTS.DATE_RANGE_DROPDOWN.ALL_TIME' | translate }}
      </button>
      <button
        class="soft-ds-drdd-confirm"
        type="button"
        [disabled]="!draftValue()?.from || !draftValue()?.to"
        (click)="onConfirm()"
      >
        {{ '#UI_CORE.COMPONENTS.DATE_RANGE_DROPDOWN.APPLY' | translate }}
      </button>
    </div>
  </div>
</ng-template>
